import { DateTime } from 'luxon';

const generateYearOptions = () => {
    const currentYear = DateTime.now().year;
    let result = [];
    for (let i = 2016; i <= currentYear; i++) {
        result.unshift({
            label: i,
            value: i,
        });
    }
    return result;
};

const YEAR_OPTIONS = generateYearOptions();

export { generateYearOptions, YEAR_OPTIONS };
